import moment from 'moment';
import { Constant } from 'src/constant';

export function showDiscoverModal(counter: number, lastVisit: string = moment().toISOString()): Boolean {
    const diff = moment(lastVisit).diff(moment());
    const diffAsTargetUnit = moment.duration(diff).as(Constant.splashScreen.maxDelayBetween2Visits.unit);
    if (diffAsTargetUnit > Constant.splashScreen.maxDelayBetween2Visits.value || !(counter % (Constant.splashScreen.visitsCountToShow))) {
        return true;
    }
    return false;
}
